import { render, staticRenderFns } from "./CompleteProposal.vue?vue&type=template&id=0fd42aa0&scoped=true&"
import script from "./CompleteProposal.vue?vue&type=script&lang=js&"
export * from "./CompleteProposal.vue?vue&type=script&lang=js&"
import style0 from "./CompleteProposal.vue?vue&type=style&index=0&id=0fd42aa0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd42aa0",
  null
  
)

export default component.exports